// 滚动到指定元素位置
const scrollToTarget = (target, smoothScroll) => {
  let mql = window.matchMedia('(max-width: 767px)');
  let isMobile = mql.matches;
  let fixedHeaderHeight = 0;
  let realTarget = target;
  const parentSection = target.closest('.shopify-section');
  if (parentSection.classList.contains('newsletter-section')) {
    realTarget = parentSection;
  }
  let distance = window.scrollY + realTarget.getBoundingClientRect().top;
  const fixHeaderNavigation = document.querySelector('#StickyHeaderWrap #SiteHeader.site-header--stuck');
  const ul = document.querySelector('#pProductOverviewMenu ul');
  const catalog = ul ? getComputedStyle(ul).height : '0px';
  if (fixHeaderNavigation) {
    const fixHeaderNavigationHeight = getComputedStyle(fixHeaderNavigation).height;
    fixedHeaderHeight = Number(fixHeaderNavigationHeight.replace('px', '')) + Number(catalog.replace('px', ''));
  } else {
    const headerNavigation = document.querySelector('#SiteHeader');
    const trustBar = document.querySelector('#SiteHeader .trust-bar');
    let headerNavigationHeight = getComputedStyle(headerNavigation).height
    if (trustBar) {
      headerNavigationHeight = Number(headerNavigationHeight.replace('px', '')) + (isMobile ? 38 : 40);
    }
    fixedHeaderHeight = headerNavigationHeight + Number(catalog.replace('px', ''));
    distance -= isMobile ? 40 : 69;
  }

  savedFixedHeaderHeight = fixedHeaderHeight;

  const headerCountDown = document.querySelector('.shopify-section-group-header-group.countdown-section');
  if (headerCountDown && headerCountDown.style.display === 'block' && !headerCountDown.classList.contains('hide')) {
    let headerCountDownHeight = fixHeaderNavigation ? 0 : headerCountDown.clientHeight;
    if (isMobile) {
      headerCountDownHeight = 0;
    }
    
    if (smoothScroll) {
      window.scrollTo({
        top: distance - fixedHeaderHeight + 1 - headerCountDownHeight,
        left: 0,
        behavior: 'smooth'
      })
    } else {
      window.scrollTo(0, distance - fixedHeaderHeight + 1 - headerCountDownHeight);
    }
  } else {
    if (smoothScroll) {
      window.scrollTo({
        top: distance - fixedHeaderHeight + 1,
        left: 0,
        behavior: 'smooth'
      })
    } else {
      window.scrollTo(0, distance - fixedHeaderHeight + 1);
    }
  }
}

// 获取 url 里 ? 后的指定 key 的值
function getURLParameter(key) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + key + "=([^&;]+?)(&|#|;|$)", "i").exec(
        location.search
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}

// 打开页面，然后滚动到指定 ID
function getElement(id) {
  const target = document.getElementById(id);
  if (target) {
    scrollToTarget(target);
  } else {
    requestAnimationFrame(() => getElement(id)); // 若元素未找到，继续尝试
  }
}
const openAndScroll = () => {
  const targetId = getURLParameter('id');
  if (targetId) {
    getElement(targetId);
  }
};
openAndScroll();

;(function() {
	var throttle = function(type, name, obj) {
		obj = obj || window;
		var running = false;
		var func = function() {
			if (running) { return; }
			if (timeout) clearTimeout(timeout);
			running = true;
			var timeout = setTimeout(() => {
					obj.dispatchEvent(new CustomEvent(name));
					running = false;
			},500)
		};
		obj.addEventListener(type, func);
	};

	/* init - you can init any event */
	throttle("resize", "optimizedResize");
})();

function syncCartDrawer(val) {
  if (val.sections && val.sections['mini-cart']) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(val.sections['mini-cart'], 'text/html');
  
    const cartDrawer = document.querySelector('#CartDrawer');
    cartDrawer.innerHTML = doc.querySelector("#CartDrawer").innerHTML;
  }
}

function addProduct(item) {
  const productId = item.dataset.productId;
  const formId = item.dataset.formId;
  const recommendationForm = document.querySelector('.recommendation-form');
  const idInput = document.querySelector('.recommendation-form input[name="id"]');
  const addToCartBtn = document.querySelector('.recommendation-form .add-to-cart');
  recommendationForm.id = formId;
  idInput.value = productId;
  addToCartBtn.click();
  item.classList.add('btn--loading');
}

document.addEventListener('productCart:updated', function(event) {
  const cart = event.detail.cart; // Get the updated content of the cart
  const items = cart.items;
  const itemIDArray = [];
  
  if (items && items.length > 0) {
    items.forEach((item) => {
      itemIDArray.push(item.variant_id);
    })
  }
  sessionStorage.itemIDArray = JSON.stringify(itemIDArray);
});

(() => {
  const originalTitle = document.title;

  let tabInterval = null;
  let wasHidden = false;
  let reminderTimer = null;
  let reminderRemoveTimer = null;

  /**
   * 判断是否为移动端
   */
  const isMobile = () => {
    return window.matchMedia('(max-width: 767px)').matches;
  };

  /**
   * 获取 Shopify Cart
   */
  async function getCart() {
    if (!window.theme?.cart?.getCart) {
      return null;
    }

    try {
      return await window.theme.cart.getCart();
    } catch (error) {
      console.warn('Unable to get cart:', error);
      return null;
    }
  }

  /**
   * 判断当前是否已有 Drawer 打开
   */
  function isDrawerOpen() {
    return !!document.querySelector('.js-drawer-open');
  }

  /**
   * 移除移动端购物车提醒
   */
  function removeCartReminder() {
    if (reminderTimer) {
      clearTimeout(reminderTimer);
      reminderTimer = null;
    }

    if (reminderRemoveTimer) {
      clearTimeout(reminderRemoveTimer);
      reminderRemoveTimer = null;
    }

    const reminder = document.getElementById(
      'noxlumin-cart-reminder'
    );

    if (!reminder) {
      return;
    }

    reminder.classList.remove('is-visible');

    reminderRemoveTimer = setTimeout(() => {
      if (reminder.isConnected) {
        reminder.remove();
      }

      reminderRemoveTimer = null;
    }, 300);
  }

  /**
   * 打开 Motion Cart Drawer
   *
   * 优先模拟点击主题原本的购物车按钮。
   * 如果当前页面找不到，则跳转 /cart。
   */
  function openCartDrawer() {
    const cartDrawerTrigger = document.querySelector(
      'a.js-drawer-open-cart'
    );

    if (cartDrawerTrigger) {
      cartDrawerTrigger.click();
      return;
    }

    window.location.href = '/cart';
  }

  /**
   * 显示移动端底部购物车提醒
   */
  function showCartReminder() {
    /**
     * 如果当前已有 Drawer 打开，
     * 不创建提醒。
     */
    if (isDrawerOpen()) {
      removeCartReminder();
      return;
    }

    /**
     * 如果已有提醒，先移除
     */
    const existing = document.getElementById(
      'noxlumin-cart-reminder'
    );

    if (existing) {
      existing.remove();
    }

    /**
     * 清除之前可能存在的定时器
     */
    if (reminderTimer) {
      clearTimeout(reminderTimer);
      reminderTimer = null;
    }

    if (reminderRemoveTimer) {
      clearTimeout(reminderRemoveTimer);
      reminderRemoveTimer = null;
    }

    /**
     * 创建提醒
     */
    const reminder = document.createElement('div');

    reminder.id = 'noxlumin-cart-reminder';

    reminder.innerHTML = `
      <span class="noxlumin-cart-reminder__text">
        Your cart is still here
      </span>

      <button
        type="button"
        class="noxlumin-cart-reminder__button"
        aria-label="View Cart"
      >
        View Cart
      </button>
    `;

    document.body.appendChild(reminder);

    /**
     * View Cart 点击事件
     */
    const viewCartButton = reminder.querySelector(
      '.noxlumin-cart-reminder__button'
    );

    viewCartButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      /**
       * 先关闭底部提醒
       */
      removeCartReminder();

      /**
       * 等当前点击事件完全结束后，
       * 再触发主题原本的 Cart Drawer 按钮。
       */
      setTimeout(() => {
        openCartDrawer();
      }, 0);
    });

    /**
     * 触发进入动画
     */
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        /**
         * 动画执行前再次检查 Drawer 状态。
         * 如果这时其他 Drawer 已经打开，则直接移除。
         */
        if (isDrawerOpen()) {
          removeCartReminder();
          return;
        }

        if (reminder.isConnected) {
          reminder.classList.add('is-visible');
        }
      });
    });

    /**
     * 8 秒后自动消失
     */
    reminderTimer = setTimeout(() => {
      removeCartReminder();
    }, 8000);
  }

  /**
   * 插入移动端提醒 CSS
   */
  if (
    !document.getElementById(
      'noxlumin-cart-reminder-style'
    )
  ) {
    const style = document.createElement('style');

    style.id = 'noxlumin-cart-reminder-style';

    style.textContent = `
      #noxlumin-cart-reminder {
        position: fixed;

        left: 16px;
        right: 16px;

        bottom: calc(
          16px + env(safe-area-inset-bottom)
        );

        z-index: 9999;

        display: flex;
        align-items: center;
        justify-content: space-between;

        gap: 16px;

        max-width: 520px;
        margin: 0 auto;

        padding: 12px 12px 12px 16px;

        background: rgba(20, 20, 20, 0.96);
        color: #fff;

        border-radius: 10px;

        box-shadow:
          0 4px 16px rgba(0, 0, 0, 0.16),
          0 10px 30px rgba(0, 0, 0, 0.12);

        opacity: 0;

        transform: translateY(
          calc(
            20px + env(safe-area-inset-bottom)
          )
        );

        transition:
          opacity 0.3s ease,
          transform 0.3s ease;

        pointer-events: none;
      }

      #noxlumin-cart-reminder.is-visible {
        opacity: 1;
        transform: translateY(0);
        pointer-events: auto;
      }

      .noxlumin-cart-reminder__text {
        min-width: 0;

        font-size: 14px;
        line-height: 1.4;
        font-weight: 500;

        color: #fff;
      }

      .noxlumin-cart-reminder__button {
        flex-shrink: 0;

        display: inline-flex;
        align-items: center;
        justify-content: center;

        min-height: 38px;

        padding: 8px 16px;
        margin: 0;

        background: #fff;
        color: #111;

        border: 0;
        border-radius: 7px;

        font: inherit;
        font-size: 13px;
        line-height: 1;
        font-weight: 600;

        cursor: pointer;

        appearance: none;
        -webkit-appearance: none;

        transition:
          background-color 0.2s ease,
          transform 0.2s ease;
      }

      .noxlumin-cart-reminder__button:hover {
        background: #f2f2f2;
      }

      .noxlumin-cart-reminder__button:active {
        transform: scale(0.97);
      }

      .noxlumin-cart-reminder__button:focus-visible {
        outline: 2px solid #fff;
        outline-offset: 2px;
      }

      /**
       * PC 不显示底部提醒
       */
      @media (min-width: 768px) {
        #noxlumin-cart-reminder {
          display: none !important;
        }
      }

      /**
       * 尊重系统减少动画设置
       */
      @media (prefers-reduced-motion: reduce) {
        #noxlumin-cart-reminder,
        .noxlumin-cart-reminder__button {
          transition: none;
        }
      }
    `;

    document.head.appendChild(style);
  }

  /**
   * 页面可见性变化
   */
  document.addEventListener(
    'visibilitychange',
    async () => {
      /**
       * 每次状态变化先停止 PC 标题循环
       */
      if (tabInterval) {
        clearInterval(tabInterval);
        tabInterval = null;
      }

      /**
       * --------------------------
       * 用户离开当前页面
       * --------------------------
       */
      if (document.hidden) {
        wasHidden = true;

        const cart = await getCart();

        /**
         * 购物车为空
         */
        if (!cart?.item_count) {
          return;
        }

        const reminderTitle =
          '🛒 Your cart is waiting';

        /**
         * M 端：
         * 只修改一次页面标题。
         */
        if (isMobile()) {
          document.title = reminderTitle;
          return;
        }

        /**
         * PC：
         * 立即修改标题
         */
        document.title = reminderTitle;

        /**
         * PC：
         * 原标题与购物车提醒交替
         */
        tabInterval = setInterval(() => {
          document.title =
            document.title === originalTitle
              ? reminderTitle
              : originalTitle;
        }, 1800);

        return;
      }

      /**
       * --------------------------
       * 用户重新回到页面
       * --------------------------
       */

      document.title = originalTitle;

      /**
       * PC 不显示底部提醒
       */
      if (!isMobile()) {
        return;
      }

      /**
       * 必须真的离开过当前页面
       */
      if (!wasHidden) {
        return;
      }

      wasHidden = false;

      const cart = await getCart();

      /**
       * 购物车为空
       */
      if (!cart?.item_count) {
        return;
      }

      /**
       * 如果当前已有 Drawer 打开，
       * 不显示底部购物车提醒。
       */
      if (isDrawerOpen()) {
        removeCartReminder();
        return;
      }

      /**
       * M 端显示底部提醒
       */
      showCartReminder();
    }
  );
})();

/**
 * 智能下载函数：自动识别后缀，支持跨域
 * @param {Event} event - 点击事件
 * @param {string} [customName] - 可选：自定义文件名（不带后缀也没关系）
 */
async function smartDownload(event, customName) {
  const link = event.currentTarget;
  const url = link.href;

  // 1. 拦截默认跳转
  event.preventDefault();
  
  // 视觉反馈：防止连点
  const originalStyle = link.style.opacity;
  link.style.opacity = '0.5';
  link.style.pointerEvents = 'none';
  const originalText = link.innerText;
  link.innerText = 'Downloading...';

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Download error');
    const blob = await response.blob();

    // 2. 确定后缀名 (Extension)
    // 逻辑：先从 URL 取，取不到再看 MIME 类型
    let extension = url.split('.').pop().split(/[?#]/)[0].toLowerCase();
    if (extension.length > 4 || extension.includes('/')) {
      // 如果 URL 里没后缀，从 Content-Type 里猜 (例如 image/png -> png)
      extension = blob.type.split('/')[1] || '';
    }

    // 3. 确定最终文件名
    let fileName = '';
    if (customName) {
      // 如果自定义了名字，且没写后缀，就把后缀补上
      fileName = customName.includes('.') ? customName : `${customName}.${extension}`;
    } else {
      // 没传名字，直接从 URL 截取原始文件名
      fileName = url.substring(url.lastIndexOf('/') + 1).split(/[?#]/)[0] || 'file';
      fileName = decodeURIComponent(fileName);
    }

    // 4. 执行下载
    const blobUrl = URL.createObjectURL(blob);
    const tempLink = document.createElement('a');
    tempLink.href = blobUrl;
    tempLink.download = fileName;
    document.body.appendChild(tempLink);
    tempLink.click();

    // 5. 释放资源
    document.body.removeChild(tempLink);
    URL.revokeObjectURL(blobUrl);

  } catch (error) {
    console.warn('Fetch 下载失败，降级为新窗口打开:', error);
    window.open(url, '_blank');
  } finally {
    link.style.opacity = originalStyle;
    link.style.pointerEvents = 'auto';
    link.innerText = originalText;
  }
}